// src/telemetry/appInsights.ts
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";

export const reactPlugin = new ReactPlugin();

export const appInsights = new ApplicationInsights({
  config: {
    connectionString: process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING,
    // or process.env.REACT_APP_APPINSIGHTS_CONNECTION_STRING for CRA
    extensions: [reactPlugin],
    enableAutoRouteTracking: true,
    // optional: disable cookies if your policy requires
    // disableCookiesUsage: true,
  },
});

appInsights.loadAppInsights();